import React from 'react';
import styles from './index.module.css';
import PropTypes from 'prop-types';

const Checkbox = props => {
  const { label, onChange, name, checked } = props;
  return (
    <>
      <input
        type="checkbox"
        id={name}
        checked={checked}
        className={styles.checkboxInput}
      />
      <label class={styles.container} htmlFor={name} onClick={onChange}>
        <span class={styles.checkmark}></span>
        {label}
      </label>
    </>
  );
};
Checkbox.propTypes = {
  onChange: PropTypes.func
};

export default Checkbox;
